import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Tile } from '../partials';
import OpSlider from "~/js/components/op-slider";
import anime from "animejs";
import roundTo from 'round-to';
import { w } from './../utils';
import ReactDOMServer from 'react-dom/server';

let regions = [];
let ribbonData = {};
class VehicleTiles extends Component {

    state = {
        vehicles: [],
        refs: []
    };

    constructor (props) {
        super(props);
        regions = props.regions;
        ribbonData = props.ribbonData;
    };

    componentDidMount() {

        let fetchUrl = '/api/v1/latestVehicles'; //'api/v1/vehicles';

        if (window.is_latest_vehicles) {
            fetchUrl = '/content/json/newarrivals.json';
        }

        if (window.is_make_page) {
            fetchUrl = `/api/v1/latestVehiclesByMake/${window.use_make}`;
        }

        if (window.is_electric_vehicles) {
            fetchUrl = `/api/v1/latestVehiclesByFuel/${window.use_fuel}`;
        }

        if (window.is_vehicle_page) {
            let vehicle = {
                dealer: window.current_vehicle['@BODY_SEQ'] || false,
                yard : window.current_vehicle['@BODY_YARD_SEQ'] || false,
                make: window.use_make || false,
                id:  window.current_vehicle['@LISTING_SEQ'] || false,
                bodytype: window.current_vehicle['@LISTING_BODY_TYPE'] || false,
                model: window.current_vehicle['@LISTING_MODEL'] || false,
                year :window.current_vehicle['@LISTING_YEAR'] || false,
                currentPrice: window.use_price || false,
            }
            let queryString = new URLSearchParams(vehicle).toString();

            fetchUrl = `/api/v1/getRelatedVehicles?${queryString}`;
        }

        if (window.is_dealer_page) {
            fetchUrl = `/api/v1/latestVehiclesByDealer/${window.use_dealer}`;
        }

        const stringExtra = "/options"
        const fetchRibbonUrl = `/api/v1/getOptions` + stringExtra;


        if(window.is_regional_dealership){
            let stringExtra =  "/"
            window.regional_dealerships_ids.forEach((id) =>{
                stringExtra += id + "_";
            });

            fetchUrl = `/api/v1/latestVehiclesByDealers` + stringExtra;

        }

        fetch(`${fetchUrl}`)
        .then((res) => res.json())
            .then((data) => {
            this.setState({
                vehicles: data,
                refs: data.map(() => {return React.createRef()})
            }, function () {

                const { left, right, frame, list, slider } = this.props;

                const timelines = this.state.refs.map(item => {
                    return anime.timeline({
                        autoplay: false,
                        easing: 'linear',
                    }).add({
                        targets: item.current,
                        opacity: [0, 1],
                        duration: 500,
                    }, 0)
                    .add({
                        targets: item.current,
                        opacity: [1, 0],
                        duration: 500,
                    }, 500)
                });

                const slideAnimation = ({ index, sideProgress }) => {
                    if (w.w > 768) {
                        const pr = roundTo((sideProgress + 1) / 2, 6);
                        timelines[index].seek(timelines[index].duration * pr);
                    } else {
                        timelines[index].seek(timelines[index].duration * 0.5)
                    }
                };

                let config = {
                    slider,
                    frame,
                    list,
                    slides: this.state.refs.map(r => r.current),
                    prev: { targets: [left] },
                    next: { targets: [right] },
                    speed: 0.15,
                    get selectCount () {
                        let count = 4;
                        if (w.w <= 1024) count = 3;
                        if (w.w <= 768) count = 2;
                        if (w.w <= 600) count = 1;

                        return count;
                    },
                    slideAnimation,
                };
                this.slider = new OpSlider(config);
            })
        })
        .catch((err) => console.log(err))

    };

    renderItem = (item, index) => {
        return (
            <div className={`vehicle-tiles__item`} key={index} ref={this.state.refs[index]}>
                <Tile {...item} regions={regions} ribbonData={ribbonData}/>
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                {this.state.vehicles.length > 0 ? this.state.vehicles.map(this.renderItem) : null }
            </Fragment>
        );
    }
}

export default function (el, props) {
    ReactDOM.render(<VehicleTiles {...props} />, el)
}
